import { useDispatch } from "react-redux";
import { openModal } from "../redux/features/memberModalSlice";
import Image from "./Image";
export interface Props {
  imgSrc: string;
  slug: string;
  name: string;
}

export default function MemberButton({ imgSrc, name, slug }: Props) {
  const dispatch = useDispatch();

  const openMember = (member: string) => {
    dispatch(openModal(member));
  };

  return (
    <div className="flex justify-center items-center">
      <div className="flex justify-center items-center border-black w-full bg-white">
        <button
          className="duration-300 grayscale focus:grayscale-0 hover:grayscale-0 active:grayscale-0 flex justify-center items-center w-full"
          onClick={() => {
            scrollTo(0, 0);
            openMember(slug);
          }}
        >
          <Image
            src={imgSrc}
            alt={name}
            className="w-full object-contain"
            height={141}
            width={141}
          />
        </button>
      </div>
    </div>
  );
}
